import { useEffect, useState } from "react"
import { 
    SidePopupContainer, FlexColumn, Button, 
    Form, FormGroup, FlexRow, AppSpan, FormGroupWithIcon 
} from "src/style"
import { RiCloseFill } from "react-icons/ri"
import { FiChevronDown } from "react-icons/fi"

export const Add_Edit_SandboxUser: React.FC<any> = ({getSandboxUsers, rowData, close}) => {
    const [input, setInput] = useState({
        fullName: '', surname: '', email: '', 
        phoneNumber: '', role: '', serviceCategory: ''
    })

    useEffect(() => {
        if (rowData) {
            const {fullName, surname, email, phoneNumber, role, serviceCategory} = rowData
            setInput({...input, fullName, surname, email, phoneNumber, role, serviceCategory})
        }
    }, [rowData])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleSubmit (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        
        if (getSandboxUsers) getSandboxUsers()
        close()
    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="center-popup-container"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                <FlexRow justifyContent='space-between' gap='2'>
                    <AppSpan color='#101828' textSize='1.8' fontWeight="600">{rowData ? 'Edit Sandbox User' : 'Create New Sandbox User'}</AppSpan>
                    <Button 
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#000000'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{fontSize: '2.3rem'}} />
                    </Button> 
                </FlexRow>
                <Form onSubmit={handleSubmit} topMargin='2'>
                    <FormGroup>
                        <label>Full name</label>
                        <input 
                            placeholder="Enter full name" 
                            name='fullName'
                            value={input.fullName}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup> 
                    <FormGroup>
                        <label>User surname</label>
                        <input 
                            placeholder="Enter surname" 
                            name='surname'
                            value={input.surname}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup>  
                    <FormGroup>
                        <label>Admin email</label>
                        <input 
                            placeholder="Enter email" 
                            name='email'
                            value={input.email}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup>  
                    <FormGroup>
                        <label>Admin phone number</label>
                        <input 
                            placeholder="Enter phone number" 
                            name='phoneNumber'
                            value={input.phoneNumber}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup>  
                    <FormGroupWithIcon >
                        <label>Role</label>
                        <div className="input-with-icon" style={{height: '4rem'}}>
                            <select 
                                name='role'
                                value={input.role}
                                style={{color: input.role ? '#000000' : '#667085'}}
                                onChange={handleInput}
                                autoComplete="off"
                            >
                                <option value="">Select role</option>
                                <option value="Admin">Admin</option>
                                <option value="User">User</option>
                            </select>
                            <FiChevronDown className="input-with-icon-tag" />
                        </div>
                    </FormGroupWithIcon>
                    <FormGroupWithIcon >
                        <label>Service category</label>
                        <div className="input-with-icon" style={{height: '4rem'}}>
                            <select 
                                name='serviceCategory'
                                value={input.serviceCategory}
                                style={{color: input.serviceCategory ? '#000000' : '#667085'}}
                                onChange={handleInput}
                                autoComplete="off"
                            >
                                <option value="">Select service category</option>
                                <option value="Insurance">Insurance</option>
                                <option value="Payment">Payment</option>
                            </select>
                            <FiChevronDown className="input-with-icon-tag" />
                        </div>
                    </FormGroupWithIcon>
                    
                    <FlexRow justifyContent='flex-end'>
                        <Button
                            width='8.1'
                            titleSize='1.4' fontWeight="500"
                            height='4' radius='0.8'
                            bottomMargin='1' hoverColor='#0D968F'
                            hoverBgColor='#fff' borderColor='#0D968F'
                        >
                            Submit
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </>
    )
}